import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { TermsStorage } from "banco-website/classes/TermsStorage";
import { PurposeStorage } from "banco-website/classes/PurposeStorage";
import { useLoanCalculatorConstants } from "../../LoanCalculator/utils/useLoanCalculatorConstants";

export const loan_calculator_schema = z.object({
  desired_advance: z.string(),
  tenure: z.string(),
  purpose: z.string(),
});

export const useLoanCalculatorForm = () => {
  const loan_calc_constants = useLoanCalculatorConstants();

  const form_methods = useForm({
    defaultValues: {
      desired_advance: String(loan_calc_constants.default_loan_value),
      tenure: String(loan_calc_constants.default_loan_tenure),
      purpose: ""
    },
    mode: "onChange",
    resolver: zodResolver(loan_calculator_schema)
  });

  const { watch, formState: { isDirty } } = form_methods;
  const { desired_advance, tenure, purpose } = watch();

  useEffect(() => {
    if (!isDirty) {return;}
    TermsStorage.set(desired_advance, tenure);
    if (purpose) {
      PurposeStorage.setPurpose(purpose);
    }
  }, [desired_advance, tenure, purpose, isDirty]);

  return {
    form_methods,
    desired_advance,
    tenure,
    purpose,
    loan_calc_constants
  };
};
